import {invokeApi,getUserAgentInit} from '@/resource/js/GLOBAL2'
import wx from 'weixin-js-sdk'

function weixinConfig() {
    let url = window.location.href.split('#')[0];
    invokeApi('weixinapi/jsapihandler',{url:url},'post',Math.random(),function (res) {
        console.log(res);
        wexinConfigReady(res)
    })
}
function wexinConfigReady(data){
    let jsApiList=[
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'hideOptionMenu',
        'chooseImage',
        'previewImage',
        'uploadImage',
        'startRecord',
        'stopRecord',
        'onVoiceRecordEnd',
        'playVoice',
        'pauseVoice',
        'stopVoice',
        'onVoicePlayEnd',
        'uploadVoice',
        'downloadVoice',
        'openAddress',
        'openLocation',
        'getLocation',
        'hideMenuItems'
    ];
    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature,// 必填，签名
        jsApiList: jsApiList // 必填，需要使用的JS接口列表
    });
    wx.ready(function(){//如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
        wx.checkJsApi({
            jsApiList:jsApiList,
            success:function (res) {
                //以键值对的形式返回，可用的api值true，不可用为false
            }
        })
        // wx.hideMenuItems({
        //     menuList: ['menuItem:copyUrl'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        // });
    });
    wx.wxShare = function (title, link, desc, imgUrl, success,cancel, fail) {//微信分享,包含分享给好友、分享到朋友圈
        let data = {
            title: title,
            desc: desc,
            link: link,
            imgUrl: imgUrl,
            success: success || function () { }, //如果未定义，赋空事件
            cancel:cancel|| function () { },//如果未定义，赋空事件
            fail: fail || function () { } //如果未定义，赋空事件
        };
        let dataTimeline = {
            title: title,
            link: link,
            imgUrl: imgUrl,
            success: success || function () { }, //如果未定义，赋空事件
            cancel:cancel|| function () { },//如果未定义，赋空事件
            fail: fail || function () { } //如果未定义，赋空事件
        };

        wx.onMenuShareTimeline(dataTimeline);

        wx.onMenuShareAppMessage(data);
    }
}
if(getUserAgentInit() == 'isMicromessage'){
    weixinConfig();

}

export default wx


// WEBPACK FOOTER //
// ./src/resource/js/wexinJsApi.js